// tslint:disable:jsx-no-lambda
import classNames from 'classnames'
import React from 'react'
import BB8Button from './BB8Button'
import './BB8CarouselItem.scss'
export enum BB8CarouselItemStyle {
  default = 0,
  badge = 1
}

export interface IBB8CarouselItemItem {
  id: string
  desc: string
  total?: number
  subItems?: string[]
  allowEdit?: boolean
}

// TODO: decouple implementation from business logic
// e.g. what do I do if I want to pass a completely different
// item template to the carousel component?
export default function BB8CarouselItem(props: {
  selectedItem?: any
  item: IBB8CarouselItemItem
  select: (item: any) => void
  styleType?: BB8CarouselItemStyle
  allowEdit?: boolean
  clickEdit: (tem: any) => void
}) {
  return (
    <div
      className={classNames('BB8Carousel-item', {
        'selected-carousel-item': props.selectedItem && props.selectedItem.id === props.item.id
      })}
      onClick={() => props.select(props.item)}
      key={props.item.id}
      id={'carousel-item-' + props.item.id}
    >
      {!props.styleType ? (
        <div className="card-inner-wrapper">
          {props.allowEdit ? (
            <BB8Button
              color="primary"
              size="small"
              variant="contained"
              className="edit-icon"
              onClick={(e: any) => {
                e.stopPropagation()
                e.preventDefault()
                props.clickEdit(props.item)
              }}
            >
              edit
            </BB8Button>
          ) : null}
          <h5>{props.item.id}</h5>
          <div className="description">
            <p>{props.item.desc}</p>
          </div>
          <p>
            <span>{props.item.total}</span> locations mapped
          </p>
          {/* <div className="bottom-arrow" /> */}
        </div>
      ) : (
        // StyleType = badge
        <div className="card-inner-wrapper">
          <small>{props.item.id}</small>
          <h5>{props.item.desc}</h5>

          <div className="subItems-wrapper">
            {props.item.subItems &&
              props.item.subItems.map((subItem: string) => (
                <div className="subItem">{subItem}</div>
              ))}
          </div>
        </div>
      )}
    </div>
  )
}
